var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 361.307 234.267",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235.225 79.444h126.076V46.627H235.225v32.817",
    fill: "#f25b28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281.855 126.072h32.817V-.001h-32.817v126.073",
    fill: "#f25b28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.1 234.267c-10.656 0-19.385-.82-26.19-2.46-6.802-1.638-12.827-4.179-18.073-7.622l9.098-27.787c3.442 2.295 7.418 4.18 11.926 5.657 4.508 1.474 9.632 2.213 15.37 2.213 6.885 0 12.377-1.804 16.476-5.41 4.097-3.607 6.146-8.525 6.146-14.754 0-5.573-1.721-10.164-5.164-13.77-3.442-3.607-10.368-7.746-20.778-12.418-10.41-4.672-18.238-11.148-23.484-19.425-5.246-8.278-7.868-17.008-7.868-26.19 0-14.753 4.917-27.13 14.753-37.129 9.836-10 22.788-15 38.853-15 9.016 0 16.68.82 22.992 2.459 6.312 1.64 11.844 4.098 16.599 7.377l-8.361 24.344a49.564 49.564 0 00-11.558-5.41c-4.098-1.311-8.688-1.967-13.77-1.967-13.607 0-20.41 6.474-20.41 19.426 0 5.738 1.803 10.41 5.41 14.015 3.606 3.607 11.189 7.992 22.746 13.156 11.558 5.164 19.795 11.763 24.714 19.795 4.917 8.033 7.377 17.294 7.377 27.786 0 15.245-5.288 27.91-15.861 37.99-10.574 10.084-24.222 15.124-40.943 15.124",
    fill: "#5a9f23",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.59 160.744v71.064H44.756v-71.064L0 62.63h41.803l24.345 63.933 26.066-63.933h37.623",
    fill: "#4f4c4c",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "3132fc406fc11c36d65c67ad20e1a8a5.svg";
export { SvgYs as ReactComponent };